<template>
  <v-dialog v-model="dialog" width="600" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        class="create-item"
        color="#2CBF56"
        depressed
        rounded
      >
        Создать планшет
        <v-icon class="ml-2" size="20">mdi-plus-circle</v-icon>
      </v-btn>
    </template>
    <v-card class="rounded-lg">
      <v-card-title class="pb-0">
        <v-row align="center" justify="space-between">
          <v-col class="px-0" cols="auto"></v-col>
          <v-col class="px-0" cols="auto">
            <p class="dialog-title">Создание планшета</p>
          </v-col>
          <v-col class="px-0" cols="auto">
            <v-btn icon @click="resetState">
              <v-icon size="30" color="error">mdi-close-thick</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text style="padding: 15px 40px">
        <v-form v-model="valid">
          <div class="input-wrapper">
            <label for="device_key"
              >Серийный ключ <span class="red--text">*</span>
            </label>
            <v-text-field
              autocomplete="off"
              placeholder="Введите серийный ключ"
              v-model="device.device_key"
              :rules="rules.required"
              id="device_key"
              counter
              maxlength="16"
              outlined
              dense
            />
          </div>
          <div class="input-wrapper">
            <label for="secret_key"
              >Секретный пароль для авторизации <span class="red--text">*</span>
            </label>
            <v-text-field
              autocomplete="off"
              placeholder="Введите пароль"
              v-model="device.secret_key"
              :rules="rules.required"
              id="secret_key"
              outlined
              dense
              counter="8"
            />
          </div>
          <div class="input-wrapper">
            <label for="branch">Филиал <span class="red--text">*</span> </label>
            <v-select
              placeholder="Выберите филиал"
              v-model="device.branch_id"
              :rules="rules.required"
              :items="branch"
              item-text="title"
              item-value="id"
              id="branch_id"
              outlined
              dense
            />
          </div>
          <div class="input-wrapper">
            <label for="city">Город <span class="red--text">*</span> </label>
            <v-select
              placeholder="Выберите город"
              v-model="device.city_id"
              :rules="rules.required"
              :items="cities"
              item-text="name"
              item-value="id"
              id="city"
              outlined
              dense
            ></v-select>
          </div>
          <div class="input-wrapper">
            <label for="branch_id">Расположение </label>
            <v-select
              v-model="device.entrance_type"
              :items="entrance_type"
              item-text="name"
              item-value="id"
              outlined
              dense
            ></v-select>
          </div>
          <div class="d-flex flex-row align-center justify-space-between">
            <div class="input-wrapper" style="width: 48%">
              <label for="street">Улица </label>
              <v-text-field
                autocomplete="off"
                placeholder="Введите название улицы"
                v-model="device.street"
                :rules="rules.required"
                id="street"
                outlined
                dense
              />
            </div>
            <div class="input-wrapper" style="width: 48%">
              <label for="building_number">Номер здания </label>
              <v-text-field
                autocomplete="off"
                placeholder="Номер здания"
                v-model="device.building_number"
                :rules="rules.required"
                id="building_number"
                outlined
                dense
              />
            </div>
          </div>
          <v-btn
            @click="createDevice"
            :disabled="!valid"
            class="save-btn"
            depressed
            >Сохранить</v-btn
          >
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "CreateDevice",
  props: {
    branch: {
      type: Array,
      required: true,
    },
    cities: {
      type: Array,
      required: true,
    },
  },
  data: () => {
    return {
      device: {},
      dialog: false,
      valid: false,
      entrance_type: ["AT_ENTRANCE", "AT_EXIT", "NOT_DEFINED"],
      rules: {
        required: [(v) => !!v || "Поле обязательно для заполнения"],
        device_key: [
          (v) => {
            if (v) {
              if (v.length > 0 && v.length <= 16) {
                return true;
              }
              return "Поле должно содержать в себе 16 символов";
            }
            return "Поле обязательно для заполнения";
          },
        ],
        secret_key: [
          (v) => {
            if (v) {
              if (v.length > 8) {
                return true;
              }
              return "Поле должно содержать в себе минимум 8 символов";
            }
            return "Поле обязательно для заполнения";
          },
        ],
      },
    };
  },
  methods: {
    resetState() {
      this.device = {};
      this.dialog = false;
    },

    async createDevice() {
      try {
        await this.$axios.post("devices/create/", this.device);
        this.$root.$emit("showCustomSuccess", "Планшета успешно создан!");
        this.$emit("refreshData");
      } catch (result) {
        this.$root.$emit("showCustomError", result);
      } finally {
        this.resetState();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.create-item {
  width: 240px;
  height: 41px;

  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 21px;
  letter-spacing: 0.1px;
  color: #ffffff;
  text-transform: none !important;
}
.dialog-title {
  font-family: Gilroy-Medium, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 26px;
  line-height: 31px;
  text-align: center;
  color: #3474d3;
}
.preview {
  position: relative;
  height: 125px;
  width: 125px;

  .delete-btn {
    position: absolute;
    right: 0;
    top: 0;
  }
}
</style>
